import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  search: {
    flex: 10,
    background: "white",
    borderRadius: "4px",
    marginLeft: "2vw",
    maxWidth: "200px",
    width: 228,
    [theme.breakpoints.down("sm")]: {
      width: 200,
    },
    [theme.breakpoints.down("xs")]: {
      width: 150,
    },
  },
  searchIcon: {
    color: "#E2E2E2",
  },
}))

export default styles

// search: {
//   flex: 10,
//   background: "white",
//   borderRadius: "4px",
//   marginLeft: "2px",
//   maxWidth: "200px",
//   width: 228,
//   [theme.breakpoints.down("sm")]: {
//     width: 200,
//   },
// [theme.breakpoints.down("xs")]: {
//   width: 150,
// },
//   searchIcon: {
//     color: "#E2E2E2",
//   },
// },
